import React, { FC } from 'react';
import CreateForm from '../../../ui-component/form-component/create-form/CreateForm';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';

import Schema from '../../../../lib/paths/user_Paths.json';
import ApplicationHeading from '../../../../pages/private/online-antrag/application-heading/ApplicationHeading';
import { PLATZHALTER_TEXT } from '../../../../lib/constants/constant';
import MUIAlert from '../../../ui-component/mui-alert/MUIAlert';
const P = Schema.attributes;

const LoginDaten: FC<{
	formValue: any;
	updateFunction: (_key: string, _value: any) => void;
	loginDatenError: any;
	formErrorMessage: string;
}> = ({ formValue, updateFunction, loginDatenError, formErrorMessage }) => {
	return (
		<>
			<ApplicationHeading title="Ihre Zugangsdaten" description={PLATZHALTER_TEXT} />
			{formErrorMessage && (
				<MUIAlert
					infoType="error"
					message="Sie sind bereit registriert. Fragen Sie Ihren Nutzerverwalter für die Freischaltung des Account"
				/>
			)}
			<Grid2 container spacing={6}>
				<Grid2 sm={6}>
					<CreateForm
						formValues={formValue}
						formStruc={formStrucEmail()}
						updateFormValuesFunc={updateFunction}
						formErrors={loginDatenError}
						readOnly={true}
					/>
				</Grid2>
			</Grid2>

			<Grid2 container spacing={6}>
				<Grid2 sm={6}>
					<CreateForm
						formValues={formValue}
						formStruc={formStrucUsername()}
						updateFormValuesFunc={updateFunction}
						formErrors={loginDatenError}
					/>
				</Grid2>
			</Grid2>

			<Grid2 container spacing={6}>
				<Grid2 sm={6}>
					<CreateForm
						formValues={formValue}
						formStruc={formStrucPassword()}
						updateFormValuesFunc={updateFunction}
						formErrors={loginDatenError}
					/>
				</Grid2>
				<Grid2 sm={6}>
					<CreateForm
						formValues={formValue}
						formStruc={formStrucPassword2()}
						updateFormValuesFunc={updateFunction}
						formErrors={loginDatenError}
					/>
				</Grid2>
			</Grid2>
		</>
	);
};

export default LoginDaten;

const formStrucEmail = () => {
	return [
		{
			fields: [P.email],
			userProps: { columnToDivide: 1 },
		},
	];
};

const formStrucUsername = () => {
	return [
		{
			fields: [P.username],
			userProps: { columnToDivide: 1 },
		},
	];
};

const formStrucPassword = () => {
	return [
		{
			fields: [P.password],
			userProps: { columnToDivide: 1 },
		},
	];
};

const formStrucPassword2 = () => {
	return [
		{
			fields: [P.repeatPassword],
			userProps: { columnToDivide: 1 },
		},
	];
};
